import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ef2dc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foot" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "copyright" }
const _hoisted_8 = ["innerHTML"]

import { RootState } from '@/store';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore<RootState>();
const data = computed(() => store.state.moviesConfig);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(data).footer_logo
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).links, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: i,
            href: item.linkurl,
            target: "_blank"
          }, _toDisplayString(item.title), 9, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          innerHTML: _unref(data).footer_text
        }, null, 8, _hoisted_8)
      ])
    ])
  ]))
}
}

})